import { render, staticRenderFns } from "./TrendModal.vue?vue&type=template&id=7450e138&scoped=true"
import script from "./TrendModal.vue?vue&type=script&lang=js"
export * from "./TrendModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7450e138",
  null
  
)

export default component.exports